import _regeneratorRuntime from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _toConsumableArray from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "D:/\u9879\u76EE/blueSkyReportForm/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { getSaleData } from '@/service/sale/SaleData';
export default function useSaleData(params) {
  var loading = ref(false);
  var finished = ref(false);
  var refreshing = ref(false);
  var saleData = ref([]);
  var totalRow = ref(0);
  var totalWeight = ref('0');
  var totalPay = ref('0');
  // 获取销售记录
  var getSaleDataAsync = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _saleData$value, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            loading.value = true;
            _context.next = 4;
            return getSaleData(params.value);
          case 4:
            data = _context.sent;
            if (refreshing.value) {
              saleData.value = [];
              refreshing.value = false;
            }
            totalRow.value = data.totalRow;
            totalWeight.value = data.totalWeight;
            totalPay.value = data.totalPay;
            (_saleData$value = saleData.value).push.apply(_saleData$value, _toConsumableArray(data.list));
            // 加载状态结束
            loading.value = false;
            // 数据全部加载完成
            if (data.totalRow === saleData.value.length) {
              finished.value = true;
            }
            _context.next = 18;
            break;
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](0);
            if (params.value.pageSize != 1) {
              params.value.pageSize -= 1;
            }
            refreshing.value = false;
          case 18:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 14]]);
    }));
    return function getSaleDataAsync() {
      return _ref.apply(this, arguments);
    };
  }();
  var onLoad = function onLoad() {
    params.value.pageSize += 1;
    getSaleDataAsync();
  };
  var onRefresh = function onRefresh() {
    // 清空列表数据
    finished.value = false;
    params.value.pageSize = 1;
    getSaleDataAsync();
  };
  return [saleData, totalRow, totalWeight, totalPay, loading, finished, refreshing, onRefresh, getSaleDataAsync, onLoad];
}